import Users from "../../../components/users/Users";

const SuperUserPage = () => {
  return (
    <>
      <section className='content-wrapper'>
          <Users/>
      </section>
    </>
  )
}

export default SuperUserPage;
 